import React, { useContext, useEffect } from "react";

import "./style.scss";
import data from "./data";
import { CheckListItem } from "./checklistItem";
import Button from "../Button";
import Tag from "../Tag";
import Features from "../Features";
import { LanguageContext, text } from "../../container/language";
import Tags from "../Tags";
import styled from "styled-components";
import Link from "../../utils/Link";
import { buildURLForArticle } from "../../utils/buildURL";

const CheckList = styled.ul`
    li {
        color: ${props => props.color || 'white'};
    }

    @media(max-width: 47.9em){
        li {
            color: #445267;
        }
    }
`

const Title = styled.div`
    color: ${props => props.color || 'white'};
    @media(max-width: 47.9em){
        color: #445267;
    }
`

const BigHero = ({ data }) => {
    const { userLanguage } = useContext(LanguageContext)
    const { mobileScreen, desktopScreen, title, description, tags, links, textColor } = data;

    useEffect(() => {
        const list = document.getElementsByClassName("check-list")
    })

    return (
        <>
            <div className="account-preview">
                <div className="account-preview__image account-preview__image--right" style={{ backgroundColor: "#1890d2" }}>
                    <picture>
                        <source srcSet={desktopScreen.url} media="(min-width: 48em)" />
                        <img srcSet={mobileScreen.url} />
                    </picture>
                </div>
                <div className="account-preview__text">
                    <Tags data={tags} />
                    <div className="account-preview__title">
                        <Title color={textColor}>{text(title, userLanguage)}</Title>
                    </div>
                    <CheckList className="check-list" color={textColor} dangerouslySetInnerHTML={{ __html: text(description, userLanguage) }} />
                    <p>
                        {links.map(({ label, backgroundColor, textColor, article, url, icon }) => (
                            <Button key={url} color={backgroundColor}>
                                {url && <a style={{ color: textColor, textDecoration: "none" }} target="_blank" href={url}>{text(label, userLanguage)}</a>}
                                {article && <Link style={{ color: textColor, textDecoration: "none" }} to={buildURLForArticle(article, false)} >
                                    <font><font>{text(label, userLanguage)}</font></font><i className={`fa fa-${icon}`}></i>
                                </Link>}
                            </Button>
                        ))}
                    </p>
                </div>
            </div>

        </>
    )
}

export default BigHero;